import Vue from 'vue';
import Component from 'vue-class-component';
import { EventEmitter } from 'events';

import WithRender from './SharedComponent.template';

import { createShareComponentAction } from '@/Framework/app/store/actions/creators';
import { EVENTS, MESSAGE_TYPES } from '@/Common/Runtime/events';

import { VueClass } from 'vue-class-component/lib/declarations';

interface ISharedComponentData {
	requestedAppId: string;
	requestedComponentName: string;
	isError: boolean;
	realComponentName: string;
}

const SharedComponentProps = Vue.extend({
	props: {
		appId: String,
		componentName: String,
		useLoading: {
			type: Boolean,
			default: true
		}
	}
});

const getSharedComponent = (emitter: EventEmitter): VueClass<App.ISharedComponent> => {
	@WithRender
	@Component
	class SharedComponent extends SharedComponentProps {
		protected isReady = false;
		protected isError = false;
		protected isLoaded = false;
		protected realComponentName: string = '';

		public $refs!: Vue['$refs'] & {
			component: App.ISharedComponent;
		};

		protected get isLoading(): boolean {
			const { useLoading, isReady, isError } = this;

			return useLoading && !isReady && !isError;
		}

		protected created(): void {
			const { appId, componentName, isLoaded } = this;
			const processInitial: App.ISharedComponentProcess = {
				loading: true,
				loaded: isLoaded,
				isError: false
			};
			const handler = (data: App.IEventAction<ISharedComponentData>): void => {
				const { payload, type } = data;
				const { requestedAppId, requestedComponentName, isError = false, realComponentName } = payload;

				if (
					type === MESSAGE_TYPES.SHARE_COMPONENT &&
					appId === requestedAppId &&
					componentName === requestedComponentName
				) {
					this.isLoaded = true;

					const process: App.ISharedComponentProcess = {
						loading: false,
						loaded: this.isLoaded,
						isError
					};

					this.isReady = !isError;
					this.isError = isError;
					this.realComponentName = realComponentName;

					this.$emit('process', process);
					emitter.removeListener(EVENTS.PUBLIC.FROM_HOST, handler);
				}
			};

			emitter.addListener(EVENTS.PUBLIC.FROM_HOST, handler);
			emitter.emit(EVENTS.PRIVATE.TO_HOST, createShareComponentAction({ appId, componentName }));
			this.$emit('process', processInitial);
		}

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		public action(data: any): Promise<any> {
			return Promise.resolve(this.$refs.component.action && this.$refs.component.action(data));
		}
	}

	return SharedComponent;
};

export default getSharedComponent;
